import { render, staticRenderFns } from "./accessor-certificate-approve.vue?vue&type=template&id=6dd363b5&"
import script from "./accessor-certificate-approve.vue?vue&type=script&lang=js&"
export * from "./accessor-certificate-approve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports